<script>
    import {Component} from 'vue-property-decorator'
    import ActivityMap from '../../activities/search/ActivityMap.vue'

    @Component
    export default class ExtraServiceMap extends ActivityMap {}
</script>
